import { orderBy } from 'lodash';
import { SelectOption } from 'src/components/form/select';

export type SortByOptions = 'label' | 'value' | 'manual';

function orderedItems<Value extends string | null>(
  arr: SelectOption<Value>[],
  fieldExtractor: (v: SelectOption<Value>) => any
) {
  return orderBy(
    arr,
    // place empty value on top, no matter what the actual label is
    [(item) => (item.value ? fieldExtractor(item) : '')],
    ['asc']
  );
}

export function applySortBy<Value extends string | null = string>(
  sortBy: SortByOptions,
  arr: SelectOption<Value>[]
) {
  switch (sortBy) {
    case 'manual':
      return arr;
    case 'label':
      return orderedItems(arr, (i) => i.label.toLowerCase());
    case 'value':
      return orderedItems(arr, (i) => i.value?.toLowerCase());
  }
}
